/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line


  document.addEventListener('theme:cart:update', function(event) {
    console.log('Cart item updated:', event.detail);
    
  });

  
  document.addEventListener('theme:cart:add', function(event) {
    console.log('Product added to cart:', event.detail);
   
  });

  
  document.addEventListener('theme:cart:change', function(event) {
    console.log('Cart changed:', event.detail);
   
  });

  
  document.addEventListener('theme:product:added', function(event) {
    console.log('Product successfully added');
    
  });

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
